import Vue from 'vue'
import VueFbCustomerChat from 'vue-fb-customer-chat'

Vue.use(VueFbCustomerChat, {
  page_id: process.env.VUE_APP_FB_PAGE_ID,
  theme_color: '#F84B04',
  locale: 'en_US'
})